export default __webpack_public_path__ + "static/media/euro2024-logo.06daaf5c.png";